import { Link } from "react-router-dom";
import { Instagram, MessageCircle } from "lucide-react";
import { INSTAGRAM_URL, WHATSAPP_COMMUNITY_URL } from "../data/site";

export const Footer = () => (
  <footer className="bg-beet-deep text-white/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-4">
            <img loading="lazy" decoding="async"
              src="/logo.png"
              alt="Pranivaa Kitchens logo"
              className="h-11 w-11 rounded-full object-cover shadow-md"
            />
            <span className="font-serif text-2xl font-semibold text-white">
              Pranivaa <span className="italic text-turmeric">Kitchens</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed max-w-sm text-white/60">
            Clean vegetarian and vegan food, explained with real science. Nourishment that keeps your
            prana — your life-force — flowing. Launching first in Delhi NCR and Bengaluru.
          </p>
          <div className="flex gap-3 mt-6">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-instagram-link"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center transition-colors hover:bg-turmeric hover:text-beet-deep hover:border-turmeric"
              aria-label="Instagram"
            >
              <Instagram size={17} />
            </a>
            <a
              href={WHATSAPP_COMMUNITY_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-link"
              className="w-10 h-10 rounded-full border border-white/20 flex items-center justify-center transition-colors hover:bg-turmeric hover:text-beet-deep hover:border-turmeric"
              aria-label="WhatsApp"
            >
              <MessageCircle size={17} />
            </a>
          </div>
        </div>
        <div className="md:col-span-3">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-turmeric mb-4">Explore</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" data-testid="footer-link-philosophy" className="hover:text-turmeric transition-colors">Our Philosophy</Link></li>
            <li><Link to="/science" data-testid="footer-link-science" className="hover:text-turmeric transition-colors">The Science</Link></li>
            <li><Link to="/recipes" data-testid="footer-link-recipes" className="hover:text-turmeric transition-colors">Recipes & Rituals</Link></li>
            <li><Link to="/coming-soon" data-testid="footer-link-coming-soon" className="hover:text-turmeric transition-colors">Coming Soon</Link></li>
            <li><Link to="/community" data-testid="footer-link-community" className="hover:text-turmeric transition-colors">Community</Link></li>
          </ul>
        </div>
        <div className="md:col-span-4">
          <p className="font-mono text-xs tracking-[0.2em] uppercase text-turmeric mb-4">The Science Desk</p>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/science/diabetes" className="hover:text-turmeric transition-colors">Diabetes & Glycemic Control</Link></li>
            <li><Link to="/science/pcos" className="hover:text-turmeric transition-colors">PCOS & Hormonal Harmony</Link></li>
            <li><Link to="/science/thyroid" className="hover:text-turmeric transition-colors">Thyroid Balance</Link></li>
            <li><Link to="/science/gut-health" className="hover:text-turmeric transition-colors">Gut Microbiome</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between gap-3 text-xs text-white/40">
        <p>© {new Date().getFullYear()} Pranivaa Kitchens. Made with haldi in New Delhi.</p>
        <p className="max-w-md">
          Educational content only — not medical advice. Always consult your physician for diagnosis
          and treatment.
        </p>
      </div>
    </div>
  </footer>
);
